import React, { useEffect, useRef, useState } from 'react';
import classnames from 'classnames/bind';

import { IN_CHARGING, MENTOS_ANIMATE, MENTOS_INIT, MENTOS_LOADED, MENTOS_READY } from 'config';
import iconMentosCheck from 'images/icon_circlecheck.png';
import mentosPoster from 'images/mentos_poster.png';
import mentosVideo from 'images/mentos_video.mp4';

import styles from './index.module.sass';

const cx = classnames.bind(styles);

const Mentos = ({ state, showCheckIcon }) => {
  const [mentosState, setMentosState] = useState(MENTOS_INIT);
  const videoRef = useRef(null);

  // mentos 影片載入 or 強制中斷時再開始播放
  useEffect(() => {
    const videoSelf = videoRef.current;
    const mentosLoad = () => setMentosState(MENTOS_LOADED);

    if (videoSelf) {
      // 有影片時切換到 loaded
      videoSelf.addEventListener('loadedmetadata', mentosLoad);
    } else {
      // 沒影片時直接切換到 ready
      setMentosState(MENTOS_READY);
    }

    return () => {
      if (videoSelf) {
        videoSelf.removeEventListener('loadedmetadata', mentosLoad);
      }
    };
  }, []);

  useEffect(() => {
    const videoSelf = videoRef.current;
    let playPromise;
    let mentosReady;
    let mentosAnimate;

    // 影片切換到 loaded 時執行
    if (mentosState === MENTOS_LOADED && videoSelf) {
      mentosReady = setTimeout(() => {
        playPromise = videoSelf.play();
        playPromise?.then(() => () => {}).catch(err => console.log(err));
        setMentosState(MENTOS_READY);
      }, 300);
    }

    // 充電中切換到 ready 時執行
    if (mentosState === MENTOS_READY && state === IN_CHARGING) {
      mentosAnimate = setTimeout(() => {
        setMentosState(MENTOS_ANIMATE);
      }, 2000); // 看能否抓影片的秒數
    }

    return () => {
      if (mentosReady) clearTimeout(mentosReady);
      if (mentosAnimate) clearTimeout(mentosAnimate);
    };
  }, [mentosState, state]);

  const mentosClass = cx({
    mentos: true,
    ready: mentosState === MENTOS_READY,
    animate: mentosState === MENTOS_ANIMATE,
  });

  return (
    <div className={mentosClass}>
      <div className={styles['mentos-video']}>
        <video preload="auto" poster={mentosPoster} ref={videoRef}>
          <source src={mentosVideo} type="video/mp4" />
        </video>
      </div>
      {showCheckIcon && <img src={iconMentosCheck} alt="check" className={styles.check} />}
    </div>
  );
};

export default Mentos;

